export default "__VITE_ASSET__JkBxRZ13__"